export default {
  'aboutUs.section1.header': 'OpenDataLab 团队',
  'aboutUs.section1.subHeader': '致力于构建 AI 开放数据生态，推动数据要素对大模型领域全面赋能',
  'aboutUs.section1.desc':
    'OpenDataLab 是上海人工智能实验室的大模型数据基座团队打造的数据开放平台，现已成为中国大模型语料数据联盟开源数据服务指定平台，为开发者提供全链条的 AI 数据支持，应对和解决数据处理中的风险与挑战，推动 AI 研究及应用。',

  'aboutUs.section2.header': '活动与合作',
  'aboutUs.section2.knowMore': '了解更多',

  'aboutUs.timeLine.content1': 'OpenDataLab 正式上线，全面开源高质量数据集 1,000+',
  'aboutUs.timeLine.content2': '作为 “浦源 OpenXLab” 九大开放项目之一，亮相世界人工智能大会（WAIC）科学前沿全体会议',
  'aboutUs.timeLine.content3':
    '大模型语料联盟成立，OpenDataLab 成为其开源数据指定平台，联盟成员数超过 40 个，已发布多个大规模高质量数据集',
  'aboutUs.timeLine.content4':
    '书生 · 万卷 1.0 发布，开源数据总量超过 2 TB，下载用户数突破 3 万，下载量突破 10 万人次，已成为国内预训练开源语料的标杆',
  'aboutUs.timeLine.content5':
    '万卷CC发布，开源400GB的高质量数据，驱动书⽣·浦语2.0（InternLM2），效率性能双提升，综合性能领先开源社区',

  'aboutUs.section3.desc': 'AI 数据领域的探路者和开源数据社区的倡导者'
};
